import DA from './DA.svg';
import DFMEA from './DFMEA.svg';
import FindSolutions from './FindSolutions.svg';
import Formulation from './Formulation.svg';
import IdeaValidation from './IdeaValidation.svg';
import InventionDisclosure from './InventionDisclosure.svg';
import QuickResearch from './QuickResearch.svg';
import SearchLeft from './SearchLeft.svg';
import Roadmap from './roadmap.svg';

export default {
  DA,
  DFMEA,
  FindSolutions,
  Formulation,
  IdeaValidation,
  InventionDisclosure,
  QuickResearch,
  SearchLeft,
  Roadmap,
};
